class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 400);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    
    const gridEl = document.getElementById('ProductGridContainer');
    if (gridEl) {
      const coll = gridEl.querySelector('.collection');
      if (coll) coll.classList.add('loading');
    }
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = parsed.getElementById('ProductGridContainer');
    const currentGrid = document.getElementById('ProductGridContainer');
    if (newGrid && currentGrid) {
      currentGrid.innerHTML = newGrid.innerHTML;
      currentGrid.querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    }
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const countEl = parsed.getElementById('ProductCountDesktop') || parsed.getElementById('ProductCount');
    const count = countEl ? countEl.innerHTML : '';
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    // Update Brand Filter Pills
    const newPills = parsed.getElementById('zmBrandPillsScroll');
    const currentPills = document.getElementById('zmBrandPillsScroll');
    if (newPills && currentPills) {
      currentPills.innerHTML = newPills.innerHTML;
    }

    // Update Facet Filters Form inside Drawer
    const newFacetsForm = parsed.getElementById('FacetFiltersForm');
    const currentFacetsForm = document.getElementById('FacetFiltersForm');
    if (newFacetsForm && currentFacetsForm) {
      currentFacetsForm.innerHTML = newFacetsForm.innerHTML;
    }

    // Update Filter Drawer Trigger Badge
    const newFilterBadge = parsed.querySelector('.zm-ref-filter-badge');
    const currentFilterBtn = document.getElementById('zmOpenFilterDrawer');
    if (currentFilterBtn) {
      const currentBadge = currentFilterBtn.querySelector('.zm-ref-filter-badge');
      if (newFilterBadge) {
        if (currentBadge) {
          currentBadge.innerHTML = newFilterBadge.innerHTML;
        } else {
          currentFilterBtn.appendChild(newFilterBadge.cloneNode(true));
        }
      } else if (currentBadge) {
        currentBadge.remove();
      }
    }

    // Update Sort Tabs state
    const newSortTabs = parsed.getElementById('zmSortTabs');
    const currentSortTabs = document.getElementById('zmSortTabs');
    if (newSortTabs && currentSortTabs) {
      currentSortTabs.innerHTML = newSortTabs.innerHTML;
      if (typeof window.zmBindSortTabs === 'function') {
        window.zmBindSortTabs();
      }
    }

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));

    facetsToRender.forEach((elementToRender) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.zm-ref-active-filters', '.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (activeFacetsElement && currentElement) {
        currentElement.innerHTML = activeFacetsElement.innerHTML;
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const gridEl = document.getElementById('product-grid');
    const sectionId = gridEl ? gridEl.dataset.id : '';
    return [
      {
        section: sectionId,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    sortFilterForms.forEach((form) => {
      if (form.id === 'FacetFiltersForm') {
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/* ==========================================================================
   PRICE RANGE COMPONENT (Dual Slider + Numeric Inputs Synchronization)
   ========================================================================== */
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.minInput = this.querySelector('.zm-ref-price-input[name*="gte"]');
    this.maxInput = this.querySelector('.zm-ref-price-input[name*="lte"]');
    this.minSlider = this.querySelector('.zm-ref-range-slider--min');
    this.maxSlider = this.querySelector('.zm-ref-range-slider--max');
    this.trackFill = this.querySelector('.zm-ref-price-slider-track-fill');

    this.rangeMin = Number(this.minSlider?.min || 0);
    this.rangeMax = Number(this.maxSlider?.max || 10000);

    this.initListeners();
    this.updateTrackFill();
  }

  initListeners() {
    if (this.minSlider && this.maxSlider) {
      this.minSlider.addEventListener('input', () => {
        let minVal = Math.min(Number(this.minSlider.value), Number(this.maxSlider.value));
        this.minSlider.value = minVal;
        if (this.minInput) this.minInput.value = minVal;
        this.updateTrackFill();
      });

      this.minSlider.addEventListener('change', () => this.dispatchPriceChange());

      this.maxSlider.addEventListener('input', () => {
        let maxVal = Math.max(Number(this.maxSlider.value), Number(this.minSlider.value));
        this.maxSlider.value = maxVal;
        if (this.maxInput) this.maxInput.value = maxVal;
        this.updateTrackFill();
      });

      this.maxSlider.addEventListener('change', () => this.dispatchPriceChange());
    }

    if (this.minInput) {
      this.minInput.addEventListener('input', () => {
        if (this.minSlider && this.minInput.value !== '') {
          this.minSlider.value = Math.min(Number(this.minInput.value), Number(this.maxSlider?.value || this.rangeMax));
          this.updateTrackFill();
        }
      });
      this.minInput.addEventListener('change', () => this.dispatchPriceChange());
    }

    if (this.maxInput) {
      this.maxInput.addEventListener('input', () => {
        if (this.maxSlider && this.maxInput.value !== '') {
          this.maxSlider.value = Math.max(Number(this.maxInput.value), Number(this.minSlider?.value || 0));
          this.updateTrackFill();
        }
      });
      this.maxInput.addEventListener('change', () => this.dispatchPriceChange());
    }
  }

  updateTrackFill() {
    if (!this.trackFill) return;
    const minVal = Number(this.minSlider?.value || this.minInput?.value || 0);
    const maxVal = Number(this.maxSlider?.value || this.maxInput?.value || this.rangeMax);
    const total = this.rangeMax - this.rangeMin || 1;

    const leftPercent = Math.max(0, Math.min(100, ((minVal - this.rangeMin) / total) * 100));
    const rightPercent = Math.max(0, Math.min(100, 100 - ((maxVal - this.rangeMin) / total) * 100));

    this.trackFill.style.left = `${leftPercent}%`;
    this.trackFill.style.right = `${rightPercent}%`;
  }

  dispatchPriceChange() {
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}

customElements.define('price-range', PriceRange);

/* ==========================================================================
   FACET REMOVE COMPONENT
   ========================================================================== */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (facetLink) {
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form) {
      form.onActiveFilterClick(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);
